import { render, staticRenderFns } from "./Outros.vue?vue&type=template&id=71b8c294&scoped=true"
import script from "./Outros.vue?vue&type=script&lang=js"
export * from "./Outros.vue?vue&type=script&lang=js"
import style0 from "./Outros.vue?vue&type=style&index=0&id=71b8c294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8c294",
  null
  
)

export default component.exports